import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';

Vue.use(Vuex);

let store = new Vuex.Store({
    // The current state of the application
    state: state,

    // Get methods for the stored state.
    getters:getters,

    // Mutate (modify) the stored state. Has to be sync
    mutations:mutations,

    // Commit a new change to the stored change. Can be async.
    actions:actions
});

export default store;
